import { render, staticRenderFns } from "./StyleMeArticleContainer.vue?vue&type=template&id=5ef2954f&"
import script from "./StyleMeArticleContainer.vue?vue&type=script&lang=js&"
export * from "./StyleMeArticleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports